import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export const BrandHomeSellerWrap = styled.div`
  padding: 16px;
  border-top: 1px solid ${vars.v3Color.gray100};
`;
export const BrandHomeSeller = styled.div`
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
    color: ${vars.v3Color.gray900};
    font-weight: 500;
    &:last-child {
      flex: 1;
      color: ${vars.v3Color.gray500};
      margin-left: 8px;
    }
  }
`;
